// extracted by mini-css-extract-plugin
export var Container = "styles-module--Container--3Nao1";
export var Background = "styles-module--Background--3KzTo";